const viewReducer = (state, action) => {
  switch (action.type) {
    case 'CURRENT_VIEW':
      return action.payload;
    default:
      return state;
  }
};

export { viewReducer as default };
